import { SvgIconTypeMap } from '@material-ui/core'
import { OverridableComponent } from '@material-ui/core/OverridableComponent'
import './power-tools-paper.css'

export interface PowerToolsPaperProps {
  children?: React.ReactNode
  className?: string
  style?: React.CSSProperties
  disabled?: boolean
  elevation?: number
  Icon?: OverridableComponent<SvgIconTypeMap<unknown, 'svg'>>
}

export const PowerToolsPaper = ({
  children,
  className,
  style,
  disabled,
  elevation,
  Icon,
}: PowerToolsPaperProps): JSX.Element => {
  const classes = [
    'power-tools-paper',
    disabled ? 'power-tools-paper--disabled' : '',
    (elevation ?? 1) >= 3 ? 'power-tools-paper--elevated' : '',
    className ?? '',
  ]
    .filter(Boolean)
    .join(' ')

  return (
    <div className={classes} style={style}>
      {children}
      {Icon && <Icon className="power-tools-paper__icon" style={{ fontSize: '4rem' }} />}
    </div>
  )
}
